import { MeetingStatus } from "@fidget/common/models/meeting-status";
import { Instance, types } from "mobx-state-tree";
import { AgentReferenceType } from "../../../agent";
import { AnyUserReferenceType } from "../../../users/AnyUserReferenceType";
import { ChatItemStatus } from "../ChatItemStatus";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

/**
 * Information about a scheduled meeting. Can cover both the "meeting scheduled"
 * events and events denoting meeting alteration ("rescheduled", "cancelled").
 */
export const MeetingChatItem = types.compose(
  "MeetingChatItem",
  BaseChatItem,
  types.model({
    type: types.literal(ChatItemType.Meeting),
    user: AnyUserReferenceType,
    agent: AgentReferenceType,
    start: types.number,
    duration: types.number,
    /** CURRENT status of the meeting that the chat item is about */
    meetingStatus: types.optional(
      types.enumeration<MeetingStatus>("MeetingStatus", Object.values(MeetingStatus)),
      MeetingStatus.SCHEDULED
    ),
    /** True if the item has been changed due to meeting rescheduling or cancellation */
    changed: false,
    // FIXME: only because chat item group requires it
    status: types.optional(types.literal(ChatItemStatus.SENT), ChatItemStatus.SENT)
  })
);

export interface IMeetingChatItem extends Instance<typeof MeetingChatItem> {}
